<template>
  <h1>IngenicoList</h1>
</template>

<script>
export default {
  name: "IngenicoList"
};
</script>

<style></style>
